module.exports = __webpack_public_path__ + "static/media/ic_campaign_link.b5ebae8c.svg";